import { Box, Card, Spinner, Table, Tag, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";

export const SubscribersTable = ({ title, subscribers, total, loading }) => (
  <Box>
    <Text fontSize="md" fontWeight="semibold" color="gray.800" mb={4}>
      {title}
    </Text>

    <Card border="1px" borderColor="gray.200">
      {loading ? (
        <Box textAlign="center" p={6}>
          <Spinner color="blue.500" />
          <Text fontSize="sm" color="gray.600" mt={2}>
            Loading subscribers...
          </Text>
        </Box>
      ) : total === 0 ? (
        <Box textAlign="center" p={6}>
          <Text color="gray.500">No subscribers found</Text>
        </Box>
      ) : (
        <>
          <Box overflowX="auto">
            <Table variant="simple">
              <Thead bg="gray.50">
                <Tr>
                  <Th>Phone</Th>
                  <Th>Status</Th>
                  <Th>Connection ID</Th>
                  <Th>Device ID</Th>
                </Tr>
              </Thead>
              <Tbody>
                {subscribers.slice(0, 5).map((sub) => (
                  <Tr key={sub.id}>
                    <Td>{sub.phone}</Td>
                    <Td>
                      <Tag colorScheme={sub.status === 'online' ? 'green' : 'gray'}>
                        {sub.status}
                      </Tag>
                    </Td>
                    <Td>{sub.connection_id}</Td>
                    <Td fontSize="xs" color="gray.500">
                      {sub.device_id}
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>

          {total > 5 && (
            <Box p={4} bg="gray.50" textAlign="center">
              <Text fontSize="sm" color="gray.600">
                And {Math.max(total - 5, 0)} more subscribers
              </Text>
            </Box>
          )}
        </>
      )}
    </Card>
  </Box>
);
